import React from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  List,
  ListItem,
  ListItemText,
  useTheme,
} from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import Header from "../../../Header/Header";
import img from "./img/whatsPaymentImg.webp";
import CardsMenu from "./CardsMenu";
import CardsMenu1 from "./CardsMenu1";
import UsePayment from "./UsePayment";
import CardMenuSection from "./CardMenuSection ";
import CompanySection from "./CompanySection";
import WhatsBusinessAPI from "./WhatsBusinessAPI";
import Faq from "./Faq";
import ReviewPage from "./ReviewPage";
import FooterSection from "../FooterSection";

const paymentMethods = ["UPI", "Net Banking", "Credit & Debit Cards"];

const bgColors = ["#FAD2CF", "#FEEFC3", "#CEEAD6"];

function darkenColor(hex, percent) {
  const num = parseInt(hex.replace("#", ""), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) - amt;
  const G = ((num >> 8) & 0x00ff) - amt;
  const B = (num & 0x0000ff) - amt;

  return (
    "#" +
    (
      0x1000000 +
      (R < 255 ? (R < 0 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 0 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 0 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)
  );
}

const WhatsAppPayment = () => {
  const theme = useTheme();

  return (
    <>
      <Header />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          backgroundImage: `url('bg2.svg')`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      >
        <Box
          sx={{
            p: { xs: 3, md: 10 },
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
          }}
        >
          <Grid container spacing={5} alignItems="center">
            {/* Left Section */}
            <Grid item xs={12} md={6} order={{ xs: 2, md: 1 }}>
              <Typography
                variant="h3"
                component="h1"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "2rem", md: "3rem" },
                  lineHeight: 1.3,
                }}
              >
                WhatsApp{" "}
                <Box component="span" sx={{ color: "#00E676" }}>
                  Payments:
                </Box>{" "}
                Collect Payments Directly within{" "}
                <span style={{ color: "#00E676" }}>WhatsApp</span>
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mt: 3, fontSize: "1.2rem" }}
              >
                Transform your customer interactions by collecting payments
                directly within WhatsApp.
              </Typography>

              <Typography
                variant="h6"
                sx={{ mt: 4, fontSize: "1.3rem", fontWeight: "bold" }}
              >
                Accept payments via:
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  mt: 2,
                }}
              >
                {paymentMethods.map((item, index) => (
                  <Typography
                    key={index}
                    sx={{
                      px: 2,
                      py: 1,
                      backgroundColor: bgColors.at(index),
                      borderRadius: "20px",
                      boxShadow: 2,
                      fontWeight: 600,
                      color: darkenColor(bgColors.at(index), 50),
                      transition: "transform 0.3s ease-out",
                      "&:hover": {
                        transform: "translateY(-5px)",
                        cursor: 'pointer',
                      },
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </Box>

              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  mt: 4,
                  flexWrap: "wrap",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <Button
                  variant="contained"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    backgroundColor: "#00C851",
                    width: { xs: "100%", md: "fit-content" },
                    color: "#ffffff",
                    "&:hover": {
                      backgroundColor: "#00b34a",
                    },
                  }}
                  startIcon={<WhatsAppIcon />}
                >
                  Start for FREE →
                </Button>

                <Button
                  variant="outlined"
                  size="large"
                  sx={{
                    px: 4,
                    py: 1.5,
                    fontWeight: 600,
                    borderColor: "black",
                    width: { xs: "100%", md: "fit-content" },
                    color: "black",
                    "&:hover": {
                      borderColor: "black",
                      backgroundColor: "#f1fdf4",
                    },
                  }}
                >
                  Book a Demo
                </Button>
              </Box>
            </Grid>

            {/* Right Section - Image */}
            <Grid item xs={12} md={6} order={{ xs: 1, md: 2 }}>
              <Box
                component="img"
                src={img}
                alt="WhatsApp Payment"
                sx={{
                  width: "100%",
                  maxWidth: "560px",
                  borderRadius: "20px",
                  mx: "auto", // center image on smaller screens
                  display: "block",
                }}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>

      <CardsMenu />
      <CardsMenu1 />
      <UsePayment />
      <CardMenuSection />
      <CompanySection />
      <WhatsBusinessAPI />
      <Faq />
      <ReviewPage />
      <FooterSection />
    </>
  );
};

export default WhatsAppPayment;
